import dictionary from './dictionary.json.js';
const config = {
    resource: 'next-error',
    dictionary,
};
export default config;
//# sourceMappingURL=config.js.map